import FileUpload from "vue-upload-component";
import {
  MEDIA_UPLOAD_FILE,
  MEDIA_DELETE_FILE,
  MEDIA_UPDATE_FILE_DESCRIPTION
} from "../../../util/mutationTypes";

import {
  FILE_TYPE_NEWS_GALLERY,
  FILE_TYPE_NEWS_ATTACHMENT
} from "../../../util/enumTypes";

import _remove from "lodash/remove";

export default {
  components: { FileUpload },

  data() {
    return {
      files: [],
      validationBytype: {
        FILE_TYPE_SUGGESTION_BOX: [".doc", ".pdf", ".jpg", ".jepg", ".png"],
        FILE_TYPE_NEWS_GALLERY: [".jpg", ".jepg", ".png"],
        FILE_TYPE_NEWS_ATTACHMENT: [".doc", ".pdf"],
        FILE_TYPE_PREPARE_TOUR_PDF: [".pdf"],
        FILE_TYPE_PREPARE_TOUR_BANNER: [".jpg", ".jepg", ".png"]
      },
      uploadBtnDisabled: true,
      errorMessageShowed: false,
      uploadedFilesData: [],
      changedDescriptions: []
    };
  },
  props: {
    name: {
      default: "file"
    },
    upload: {
      default: "upload"
    },
    accept: {
      default: "image/png,image/gif,image/jpeg,application/pdf"
    },
    autoUpload: {
      default: false
    },
    drop: {
      default: true
    },
    dropDirectory: {
      default: true
    },
    extensions: {
      default: () => ["jpg", "png", "pdf"]
    },
    maxSize: {
      default: () => 1024 * 1024 * 5
    },
    maximum: {
      default: 0
    },
    multiple: {
      default: true
    },
    thread: {
      default: 3
    },
    setData: {
      default: () => []
    },
    type: {
      default: "FILE_TYPE_SUGGESTION_BOX"
    },
    hasDrop: {
      default: false
    },
    urls: {
      default: () => []
    },
    uploadedFiles: {
      default: () => []
    },
    maxCountUploads: {
      default: 5
    },
    sended: {
      default: false
    },
    small: {
      default: false
    },
    previewGallery: {
      default: () => []
    },
    previewFiles: {
      default: () => []
    }
  },
  methods: {
    uploadFiles() {
      this.files.map(f => (f.error = "")); //set files with errors 'error'='' to send it again
      this.$refs[this.upload].active = true;
    },
    checkForUploadErrors() {
      if (this.files.some(f => f.error) && !this.errorMessageShowed) {
        this.uploadBtnDisabled = false;
        if (this.type == "FILE_TYPE_SUGGESTION_BOX") {
          this.$alert(this.$t("media_uploader_upload_file_error"), "", {
            confirmButtonText: "OK"
          });
          this.errorMessageShowed = true;
        } else {
          this.$message({
            type: "warning",
            message: this.$t("media_uploader_upload_news_file_error"),
            duration: 5000
          });
        }
      }
    },

    deleteUploadedFile(url, index) {
      let fileId = url.split("/").pop();
      this.$store
        .dispatch(MEDIA_DELETE_FILE, { fileId, lang: this.lang })
        .then(data => {
          if (!data.code) {
            this.uploadedFiles.splice(index, 1);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    showValidationError() {
      this.$message({
        type: "error",
        message: this.$t("media_uploader_file_validation_error"),
        duration: 5000
      });
    },

    inputFilter(newFile, oldFile, prevent) {
      if (
        newFile &&
        newFile.size >= 0 &&
        this.maxSize > 0 &&
        newFile.size > this.maxSize
      ) {
        this.showValidationError();
        return prevent();
      }
      if (newFile && !this.isValid(newFile.name)) {
        this.showValidationError();
        return prevent();
      }
    },

    async fileAction(data) {
      const progress = {
        onUploadProgress: progressEvent => {
          data.progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        }
      };
      let formData = new FormData();
      formData.append("file", data.file);
      formData.append("type", this.type);
      formData.append("description", data.description || "");
      formData.append("fileName", data.name);

      return await this.uploadAction(formData, progress, data.id);
    },

    async uploadAction(formData, progress, fileId) {
      this.errorMessageShowed = false;
      let data;
      try {
        data = await this.$store.dispatch(MEDIA_UPLOAD_FILE, {
          formData,
          lang: this.lang,
          progress
        });
        this.setUploadedToPreviewFilesFile(fileId);
      } catch (err) {
        console.log(err);
      }
      this.urls.push(data.url);
      this.uploadedFiles.push({
        fileName: formData.get("fileName"),
        url: data.url.replace(/http.?:\/\/[^\/]*/, ""),
        description: formData.get("description")
      });

      return true;
    },

    ///////////////////// working with preview array //////////////////////
    addFileToPreviewFiles(file) {
      this.previewFiles.push({
        id: file.id,
        url:
          this.type == FILE_TYPE_NEWS_GALLERY
            ? window.URL.createObjectURL(file.file)
            : "",
        description: ""
      });
    },

    setUploadedToPreviewFilesFile(fileId) {
      if (this.previewFiles.length) {
        this.previewFiles.find(item => fileId == item.id).uploaded = "true";
      }
    },

    removeFileFromPreviewFiles(fileId) {
      _remove(this.previewFiles, item => fileId == item.id);
    },

    handlePreviewFiles(newFile, oldFile) {
      if (
        (this.type == FILE_TYPE_NEWS_GALLERY ||
          this.type == FILE_TYPE_NEWS_ATTACHMENT) &&
        newFile
      ) {
        if (!this.previewFiles.find(file => file.id == newFile.id)) {
          this.addFileToPreviewFiles(newFile);
        }
      } else if (oldFile) {
        this.removeFileFromPreviewFiles(oldFile.id);
      }
    },
    //*********************************************************************//

    inputFile(newFile, oldFile) {
      //for preview
      this.handlePreviewFiles(newFile, oldFile);
      if (this.autoUpload && newFile && !this.$refs[this.upload].active) {
        this.$refs[this.upload].active = true;
      }
    },

    removeItem(item) {
      this.$refs[this.upload].remove(item);
    },

    cleareList() {
      this.$refs[this.upload].clear();
    },
    /////////////   working with descriptions ////////////////////////
    setDescription(file, event) {
      if (this.previewFiles.length) {
        this.previewFiles.find(item => file.id == item.id).description = event;
      }
      file.description = event;
      this.$forceUpdate();
    },

    changeDescriptions(file, event) {
      let item = this.changedDescriptions.find(
        item => file.url.split("/").pop() == item.fileId
      );
      if (item) {
        item.description = event;
      } else {
        this.changedDescriptions.push({
          fileId: file.url.split("/").pop(),
          description: event
        });
      }
    },

    async setChangedDescriptions() {
      let promises = [];
      this.changedDescriptions.forEach(item => {
        promises.push(this.getChangedDescriptionPromise(item));
      });
      await Promise.all(promises);
      this.changedDescriptions = [];
    },

    getChangedDescriptionPromise(item) {
      let lang = this.lang;
      return new Promise(async (resolve, reject) => {
        try {
          await this.$store.dispatch(MEDIA_UPDATE_FILE_DESCRIPTION, {
            fileId: item.fileId,
            description: item.description,
            lang
          });
        } catch (err) {
          console.log(err);
        }
        resolve();
      });
    },
    //******************************************************************//
    isValid(fileName) {
      return new RegExp(
        "(" +
          this.validationBytype[this.type].join("|").replace(/\./g, "\\.") +
          ")$"
      ).test(fileName);
    }
  },
  computed: {
    uploadInfo() {
      return this.$t("media_uploader_upload_info", {
        extensions: this.validationBytype[this.type].join("/"),
        size: this.maxSize / 1024 / 1024,
        maxNum: this.maxCountUploads
      });
    },
    lang() {
      return this.$store.state.SettingStorage.language.toLowerCase();
    }
  },
  mounted() {
    this.$watch(
      () => {
        return this.$refs[this.upload].active;
      },
      val => {
        this.$emit("active", val);
      }
    );
    this.$watch(
      () => {
        return this.$refs[this.upload].uploaded;
      },
      val => {
        this.uploadBtnDisabled = val;
        if (val) {
          this.checkForUploadErrors();
          if (this.files.some(f => !f.error)) {
            this.$emit("uploaded", val);
          }
        }
      }
    );
  },
  watch: {
    sended(val, old) {
      if (val) {
        this.urls.splice(0, this.urls.length);
        this.files = this.files.filter(f => f.error);
      }
    }
  },
  beforeDestroy() {
    this.$emit("beforeDestroy");
  }
};
